import { render, staticRenderFns } from "./TaStatusIcon.vue?vue&type=template&id=6395f8d8&scoped=true&"
import script from "./TaStatusIcon.vue?vue&type=script&lang=js&"
export * from "./TaStatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6395f8d8",
  null
  
)

export default component.exports